import { all } from 'redux-saga/effects'

import geocodeSagas from './shared/geocode/geocodeSagas';
import appsSaga from './apps/sagas';
import organizationsSaga from './organizations/sagas';
import commonSaga from './shared/sagas';
import authSaga from './auth/sagas';
import poisSaga from './pois/sagas';
import validationSaga from './validation/sagas';
import adminSaga from './admin/sagas';

export default function* rootSaga() {
  yield all([
    geocodeSagas(),
    appsSaga(),
    organizationsSaga(),
    commonSaga(),
    authSaga(),
    poisSaga(),
    validationSaga(),
    adminSaga(),
  ])
}


// WEBPACK FOOTER //
// ./src/rootSaga.js